import {
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { t } from "i18next";
import appcolors from "../../../constants/Colors";
import { CURRENCY } from "../../../constants/Variables";
import { useSelector } from "react-redux";

const tableStyle = {
  "&.MuiTableContainer-root": {
    border: "1px solid grey",
    borderRadius: 1,
    overFlow: "hidden",
  },
  "&.MuiTableContainer-root .MuiTableHead-root": {
    backgroundColor: appcolors.primary,
  },
  "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
  {
    padding: "6px 16px",
    color: appcolors.white,
    fontSize: "1rem",
  },
};

const ServiceDetail = ({ detail, companyServiceDetail }) => {
  const { currentLanguage } = useSelector((state) => state.languageReducer);

  return (
    <TableContainer sx={tableStyle}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell>{t("image")}</TableCell>
            <TableCell>{t("service")}</TableCell>
            <TableCell>{t("price")}</TableCell>
            <TableCell>{t("description")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              <Avatar
                src={detail?.image}
                sx={{
                  height: 60,
                  width: 60,
                  borderRadius: 2,
                  border: "1px solid grey",
                }}
              />
            </TableCell>
            <TableCell
              sx={{
                fontWeight: 600,
                fontSize: "1rem",
                textTransform: "capitalize",
              }}
            >
              {detail?.name[currentLanguage]}
            </TableCell>
            <TableCell>
              {detail?.type === "fixed" && (
                <Typography variant="body2" color="text.mediumGray">
                  {t("serviceCharge")}:
                  {companyServiceDetail?.price?.fixed || 0} {" "} {CURRENCY}
                </Typography>
              )}
              {detail?.type === "area" && (
                <Typography variant="body2" color="text.mediumGray">
                  {t("perAreaCharge")}:
                  {companyServiceDetail?.price?.area || 0} {" "} {CURRENCY}
                </Typography>
              )}
              {detail?.type === "room+area" && (
                <Typography variant="body2" color="text.mediumGray">
                  {t("perAreaCharge")}:
                  {companyServiceDetail?.price?.area || 0} {" "} {CURRENCY} <br />
                  {t("perRoomCharge")}:
                  {companyServiceDetail?.price?.room || 0} {" "} {CURRENCY}
                </Typography>
              )}
              {detail?.type === "interior+exterior" && (
                <Typography variant="body2" color="text.mediumGray">
                  {t("interiorServiceCharge")}:
                  {companyServiceDetail?.price?.interior || 0} {" "} {CURRENCY} <br />
                  {t("exteriorServiceCharge")}:
                  {companyServiceDetail?.price?.exterior || 0} {" "} {CURRENCY}
                </Typography>
              )}
            </TableCell>
            <TableCell
              sx={{
                width: 400,
              }}
            >
              <Typography
                sx={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {detail?.description[currentLanguage]}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ServiceDetail;
